import { Injectable } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';


@Injectable()
export class ContactTypeService {

    constructor (private apiService: ApiService) {}

    getContactType(id?: string): Observable<ApiResponse> {
        return this.apiService.get('contact-type' + (id ? '/' + id : ''));
    }

    insertContactType(data: any): Observable<ApiResponse> {
        return this.apiService.post('contact-type', data);
    }

    deleteContactType(id: string): Observable<ApiResponse> {
        return this.apiService.delete('contact-type/' + id);
    }

    updateContactType(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('contact-type/' + id, data);
    }
}
